export default __webpack_public_path__ + "static/NBInternationalPro-Bold-34c40e5a311fdbc8e5f1151511664dfa.eot";